import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-102e3ce8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "register"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "補充資料  升級體驗", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "電郵地址", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "生日", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "新密碼", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "新密碼確認密碼", -1));
const _hoisted_8 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  },
  class: "label"
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  },
  class: "label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_dialog = _resolveComponent("van-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_form, {
    ref: "form"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_row, {
      class: "title",
      justify: "center"
    }, {
      default: _withCtx(() => [_createTextVNode(" Parent Net 教圖家長會 ")]),
      _: 1
    }), _hoisted_2, _createVNode(_component_van_row, {
      justify: "center",
      style: {
        "text-align": "center",
        "line-height": "25px",
        "font-weight": "600",
        "margin": "0 5px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 由香港教育圖書有限公司創建，提供育兒、升學、出版、各項優惠及服務信息等，務求與家長建立長久而貼心的服務及友好關係。 ")]),
      _: 1
    }), _createVNode(_component_van_row, {
      justify: "center",
      style: {
        "text-align": "center",
        "padding": "0 0"
      }
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _hoisted_4, _createVNode(_component_van_field, {
      class: "input",
      modelValue: $data.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.email = $event),
      rules: $data.rules['email'],
      type: "email",
      placeholder: "必填",
      maxlength: "50"
    }, null, 8, ["modelValue", "rules"]), _hoisted_5, _createVNode(_component_van_field, {
      modelValue: $data.birthdayLabel,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.birthdayLabel = $event),
      rules: $data.rules['birthdayLabel'],
      "is-link": "",
      readonly: "",
      class: "input",
      placeholder: "必填",
      onClick: _cache[2] || (_cache[2] = $event => $data.showPicker = true)
    }, null, 8, ["modelValue", "rules"]), _hoisted_6, _createVNode(_component_van_field, {
      modelValue: $data.password,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.password = $event),
      class: "input",
      rules: $data.rules['password'],
      placeholder: "最少8個字元,最少一個字母,最少一個數字",
      required: "",
      type: "password",
      maxlength: "20"
    }, null, 8, ["modelValue", "rules"]), _hoisted_7, _createVNode(_component_van_field, {
      modelValue: $data.confirmPassword,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.confirmPassword = $event),
      class: "input",
      rules: $data.rules['confirmPassword'],
      placeholder: "必填",
      required: "",
      type: "password",
      maxlength: "20"
    }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_row, {
      class: "label"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_col, null, {
        default: _withCtx(() => [_createVNode(_component_van_checkbox, {
          modelValue: $data.acceptNews,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.acceptNews = $event),
          "checked-color": "#633b5b",
          "icon-size": "17",
          name: "1"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "font-size": "12px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 我希望收到教圖家長會最新消息及會員優惠資訊")]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_button, {
      class: "btn-verify",
      round: "",
      size: "large",
      color: "#633b5b",
      onClick: $options.handleRegister,
      disabled: $data.submitButton,
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_createTextVNode("確認")]),
      _: 1
    }, 8, ["onClick", "disabled"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
      class: "btn-verify",
      round: "",
      size: "large",
      color: "#633b5b",
      onClick: $options.opepApp,
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_createTextVNode("登入")]),
      _: 1
    }, 8, ["onClick"])]), _createVNode(_component_van_row, {
      class: "label",
      justify: "center"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_col, {
        span: 12
      }, {
        default: _withCtx(() => [_createVNode(_component_van_image, {
          src: "iosdownload.png",
          fit: "contain"
        })]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: 12
      }, {
        default: _withCtx(() => [_createVNode(_component_van_image, {
          src: "googledownload.png",
          fit: "contain"
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 512), _createVNode(_component_van_popup, {
    show: $data.showPicker,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $data.showPicker = $event),
    round: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      title: "月份",
      columns: $data.columns,
      onCancel: _cache[6] || (_cache[6] = $event => $data.showPicker = false),
      onConfirm: $options.onConfirm
    }, null, 8, ["columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_dialog, {
    show: $data.show,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $data.show = $event),
    title: "",
    confirmButtonText: "打開app",
    onConfirm: $options.opepApp
  }, {
    default: _withCtx(() => [_createVNode(_component_van_row, {
      justify: "center",
      style: {
        "text-align": "center",
        "padding": "20px 0"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 補充資料成功，快打開APP體驗一下吧 ")]),
      _: 1
    })]),
    _: 1
  }, 8, ["show", "onConfirm"])]);
}